module.exports = __webpack_public_path__ + "img/9788992684248.fcfdb917.jpg";